var t=function(t){var r=t.text,e=t.currentWidth,n=t.textLength,g=t.separator,h=(e-t.maxWidth)/(e/n)+g.length,a=(r.length-h)/2,i=(r.length+h)/2;return r.substring(0,a)+g+r.substring(i)};export{t as getTruncatedText};
